import axios from "axios";

// Premium products

export const getFeatureStatus = () => axios.get("/api/v1/browse/orders/feature_status");

export const getIFScores = id => axios.get(`/api/v1/browse/premium_features/instant_feedback/${id}/banner_data`);
